import React, { ReactChild } from 'react';
import usePortal from 'react-useportal';

import { Body, ButtonGroup, Fade, Title, Wrapper } from './confirm.styled';

export interface IConfirmSettings {
  body: ReactChild;
  title: string;
  type: 'alert' | 'confirm';
  confirmText: string;
  dismissText: string;
}

interface Props extends IConfirmSettings {
  onConfirm: () => void;
  onDismiss: () => void;
}

export const Confirm = React.memo(
  ({
    title,
    confirmText,
    dismissText,
    body,
    type,
    onConfirm,
    onDismiss,
  }: Props) => {
    const { Portal } = usePortal();

    return (
      <Portal>
        <Fade />
        <Wrapper>
          <Title>{title}</Title>
          <Body>{body}</Body>
          <ButtonGroup $isAlert={type === 'alert'}>
            {type === 'confirm' && (
              <button
                onClick={onDismiss}
                type={'button'}
                style={{ color: '#d93030' }}
              >
                {dismissText}
              </button>
            )}
            <button onClick={onConfirm} type={'button'}>
              {confirmText}
            </button>
          </ButtonGroup>
        </Wrapper>
      </Portal>
    );
  }
);
